<template>
  <div>
    <a-modal
      v-model="isShow"
      centered
      :width="1100"
      :mask-closable="false"
      :ok-button-props="{ props: { loading: submitting } }"
      title="模组入库"
      @ok="handleSubmit"
    >
      <a-row>
        <a-form
          class="simiot-compact-form"
          :form="form"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 15 }"
          @submit="handleSubmit"
        >
          <a-col :span="11">
            <a-form-item :wrapper-col="{ span: 24 }">
              <common-module-input
                mode="import"
                :rows="32"
                @change="handleModulesChange"
                v-decorator="[
                  'modules',
                  {
                    rules: [{ validator: checkModules }],
                  },
                ]"
              />
            </a-form-item>
          </a-col>

          <a-col :span="13">
            <h4 class="title">采购属性</h4>

            <a-form-item label="采购日期">
              <a-date-picker
                style="width: 100%"
                v-decorator="[
                  'purchase_date',
                  {
                    initialValue: this.$moment(),
                    rules: [{ required: true, message: '请选择采购日期' }],
                  },
                ]"
              />
            </a-form-item>

            <a-form-item label="供应商">
              <a-select
                v-decorator="[
                  'module_supplier_id',
                  { rules: [{ required: true, message: '请选择供应商' }] },
                ]"
                show-search
                option-filter-prop="children"
                placeholder="请选择"
                :loading="loadingSupplierOptions"
              >
                <a-select-option
                  v-for="opt in supplierOptions"
                  :key="opt.id"
                  :value="opt.id"
                >
                  {{ opt.name }}
                </a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item label="采购主体">
              <a-select
                v-decorator="[
                  'contracting_party_id',
                  { rules: [{ required: true, message: '请选择采购主体' }] },
                ]"
                show-search
                option-filter-prop="children"
                placeholder="请选择签约主体"
                :loading="loadingPartyOptions"
              >
                <a-select-option
                  v-for="opt in partyOptionsFiltered"
                  :key="opt.id"
                  :value="opt.id"
                >
                  {{ opt.name }}
                </a-select-option>
              </a-select>
            </a-form-item>

            <h4 class="title">模组属性</h4>

            <a-form-item label="模组厂商">
              <a-select
                v-decorator="[
                  'module_producer_id',
                  { rules: [{ required: true, message: '请选择模组厂商' }] },
                ]"
                show-search
                option-filter-prop="children"
                placeholder="请选择"
                :loading="loadingProducerOptions"
                @change="handleProducerChange"
              >
                <a-select-option
                  v-for="opt in producerOptions"
                  :key="opt.id"
                  :value="opt.id"
                >
                  {{ opt.name }}
                </a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item label="模组型号">
              <a-select
                v-decorator="[
                  'module_model_id',
                  { rules: [{ required: true, message: '请选择模组型号' }] },
                ]"
                show-search
                option-filter-prop="children"
                placeholder="请先选择模组厂商"
                :loading="loadingModelOptions"
              >
                <a-select-option
                  v-for="opt in modelOptions"
                  :key="opt.id"
                  :value="opt.id"
                >
                  {{ opt.name }}
                </a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item label="固件版本">
              <a-input
                v-decorator="[
                  'firmware_version',
                  {
                    rules: [{ max: 100, message: '最多100个字符' }],
                  },
                ]"
                allow-clear
                placeholder="请输入固件版本"
              />
            </a-form-item>

            <a-form-item label="税点">
              <a-select
                v-decorator="[
                  'invoice_rate_id',
                  { rules: [{ required: true, message: '请选择税点' }] },
                ]"
                show-search
                option-filter-prop="children"
                placeholder="请选择"
                :loading="loadingInvoiceRateOptions"
              >
                <a-select-option
                  v-for="opt in invoiceRateOptions"
                  :key="opt.id"
                  :value="opt.id"
                >
                  {{ opt.name }}
                </a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item label="单价">
              <a-input-number
                v-decorator="[
                  'unit_price',
                  { rules: [{ required: true, message: '请输入单价' }] },
                ]"
                :min="0"
                :precision="2"
                :step="0.01"
                style="width: 100%"
                @change="syncTotal"
              />
            </a-form-item>

            <a-form-item label="总价">
              <span>{{ totalPriceDisplay }}</span>
            </a-form-item>

            <a-form-item label="备注">
              <a-textarea
                :rows="3"
                v-decorator="[
                  'remark',
                  {
                    rules: [{ max: 500, message: '最多500个字符' }],
                  },
                ]"
              />
            </a-form-item>
          </a-col>
        </a-form>
      </a-row>
    </a-modal>
  </div>
</template>

<script>
import { findCommonTypeOptions } from '@/api/common_type'
import { findContractingPartyOptions } from '@/api/contracting_party'
import { findModuleSuppliers } from '@/api/module_supplier'
import { importModuleInventories } from '@/api/module_inventory'
import { formatFloat } from '@/utils/filter'
import { formatDate } from '@/utils/time'
import CommonModuleInput from '@/components/ModuleInput/Common'

export default {
  name: 'ImportModuleInventory',
  components: { CommonModuleInput },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'module_inventory_import' }),
      submitting: false,
      supplierOptions: [],
      partyOptions: [],
      producerOptions: [],
      modelOptions: [],
      invoiceRateOptions: [],
      loadingSupplierOptions: false,
      loadingPartyOptions: false,
      loadingProducerOptions: false,
      loadingModelOptions: false,
      loadingInvoiceRateOptions: false,
      moduleCount: 0,
      totalPriceDisplay: '--'
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    partyOptionsFiltered() {
      return this.partyOptions.filter((p) => p.effective)
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.resetForm()
          this.loadOptions()
        }
      }
    }
  },
  methods: {
    resetForm() {
      this.form.resetFields()
      this.modelOptions = []
      this.moduleCount = 0
      this.totalPriceDisplay = '--'
      this.$nextTick(() => {
        this.form.setFieldsValue({ purchase_date: this.$moment() })
      })
    },

    loadOptions() {
      this.fetchSuppliers()
      this.fetchParties()
      this.fetchProducers()
      this.fetchInvoiceRates()
    },

    fetchSuppliers() {
      this.loadingSupplierOptions = true
      findModuleSuppliers({ page: 1, per_page: 500 }).then((res) => {
        if (res.code === 0) {
          this.supplierOptions = res.data
        }
        this.loadingSupplierOptions = false
      })
    },

    fetchParties() {
      this.loadingPartyOptions = true
      findContractingPartyOptions().then((res) => {
        if (res.code === 0) {
          this.partyOptions = res.data
        }
        this.loadingPartyOptions = false
      })
    },

    fetchProducers() {
      this.loadingProducerOptions = true
      findCommonTypeOptions('product_module_producer').then((res) => {
        if (res.code === 0) {
          this.producerOptions = res.data
        }
        this.loadingProducerOptions = false
      })
    },

    fetchModels(producerId) {
      this.loadingModelOptions = true
      findCommonTypeOptions('product_module_model', undefined, producerId).then((res) => {
        if (res.code === 0) {
          this.modelOptions = res.data
        }
        this.loadingModelOptions = false
      })
    },

    fetchInvoiceRates() {
      this.loadingInvoiceRateOptions = true
      findCommonTypeOptions('invoice_rate').then((res) => {
        if (res.code === 0) {
          this.invoiceRateOptions = res.data
        }
        this.loadingInvoiceRateOptions = false
      })
    },

    handleProducerChange(producerId) {
      this.form.setFieldsValue({ module_model_id: undefined })
      if (!producerId) {
        this.modelOptions = []
        this.syncTotal()
        return
      }
      this.fetchModels(producerId)
      this.syncTotal()
    },

    handleModulesChange(value) {
      this.moduleCount = value.modulesCount - value.duplicateModulesCount
      this.syncTotal()
    },

    checkModules(rule, value, callback) {
      if (!value || !value.inputValue) {
        // eslint-disable-next-line standard/no-callback-literal
        callback('请输入模组信息')
        return
      }

      if (value.validateStatus === 'error') {
        callback(value.errorMsg)
        return
      }

      // eslint-disable-next-line standard/no-callback-literal
      callback()
    },

    syncTotal() {
      this.$nextTick(() => {
        const u = this.form.getFieldValue('unit_price')
        if (this.moduleCount > 0 && u != null && u >= 0) {
          const t = Math.round(this.moduleCount * u * 100) / 100
          this.totalPriceDisplay = formatFloat(t)
        } else {
          this.totalPriceDisplay = '--'
        }
      })
    },

    handleSubmit(e) {
      if (e && e.preventDefault) {
        e.preventDefault()
      }
      if (this.submitting) {
        this.$warning({
          title: '请勿重复提交',
          content: ''
        })
        return
      }

      this.form.validateFields((err, values) => {
        if (err) {
          return
        }
        this.submitting = true
        importModuleInventories({
          ...values,
          modules: values.modules.data,
          purchase_date: formatDate(values.purchase_date)
        }).then((res) => {
          this.submitting = false
          if (res.code === 0) {
            this.$message.success('入库任务已提交')
            this.isShow = false
            this.$emit('completed')
          }
        }).catch(() => {
          this.submitting = false
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.title {
  color: @primary-color;
  padding-left: 50px;
}
</style>
